import React, { FC, ReactElement } from 'react';
import { IFormDescriptionProps } from "./IFormDescriptionProps";

const FormDescription: FC<IFormDescriptionProps> = ({formText}): ReactElement => {
  return (
    <div className="form-text mt-1 text-break">{formText}</div>
  )
};

export default FormDescription;